import http from '../../common/duck/httpService';

function getStripePublishableKey() {
    return http.get('/stripe/key').then(response => response.data.data.stripeAPIKey);
}

export default {
    getStripePublishableKey
}